import * as React from 'react';
import { useState } from 'react';
import { flow } from 'fp-ts/lib/function';
import { setLastTelestratedVideo, withTelestrationState } from '../State';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide,
    TextField,
} from '@material-ui/core';
import { ITelestrationStateMgr } from '../Types';
import { TransitionProps } from '@material-ui/core/transitions';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CheckIcon from '@material-ui/icons/Check';
import { withStyles, WithStyles as IWithStyles } from '@material-ui/core';
import SendIcon from '../../../Assets/send-icon.png';
import { CloseIcon } from 'src/Assets/svgs/CloseIcon';

interface IProps extends IWithStyles {
    telestrationStateMgr: ITelestrationStateMgr;
}

const Transition = React.forwardRef(
    (
        props: TransitionProps & { children?: React.ReactElement<any, any> },
        ref: React.Ref<unknown>
    ) => <Slide direction='up' ref={ref} {...props} />
);

const styles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'row' as 'row',
    },
    textField: {
        width: '100%',
        marginRight: '15px',
    },
    paper: {
        borderRadius: '5px',
        width: '500px',
        maxWidth: '100%',
        boxSizing: 'border-box',
    },
    dialogBox: {
        backgroundColor: '#121217',
        zIndex: 999999,
        margin: 0,
        padding: 0,
        border: '1px solid #3F3F50',
        borderRadius: '8px',
    },
    dialogHeader: {
        padding: '12px 16px',
        borderBottom: '1px solid #3F3F50',
        '& .close-icon': {
            cursor: 'pointer',
            width: 38,
            height: 38,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 8,
            '&:hover': {
                backgroundColor: 'rgba(250, 250, 250, 0.1)',
            },
        },
    },
    dialogTitle: {
        '&&': {
            padding: 0,
            '& h2': {
                fontSize: 16,
            },
        },
    },
    videoTitle: {
        width: '100%',
        marginBottom: 8,
        '& .MuiOutlinedInput-root': {
            borderWidth: 1,
            borderRadius: 8,
            fontSize: 14,
            '& input': {
                padding: '16px 8px',
            },
            '&.MuiOutlinedInput-multiline': {
                padding: 0,
                '& textarea': {
                    padding: '16px 8px',
                },
            },
            '&:hover fieldset': {
                borderWidth: 1,
                borderColor: '#ffffff',
            },
            '& fieldset': {
                borderWidth: 1,
                transition: 'border-width 0.3s ease',
            },
            '&.Mui-focused fieldset': {
                borderWidth: 1,
                borderColor: '#ffffff',
            },
        },
        '&:last-child': {
            marginBottom: 0,
        },
    },
    buttonRow: {
        borderTop: '1px solid #3F3F50',
        padding: '16px',
        textAlign: 'right' as 'right',
        gap: 8,
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 16,
        '& button': {
            borderRadius: 8,
            padding: '0 16px',
            height: 40,
            fontWeight: 400,
            textTransform: 'capitalize',
            marginLeft: 0,
            '&.MuiButton-contained:hover': {
                backgroundColor: '#B3211E',
            },
            '& .copied-style': {
                display: 'flex',
                alignItems: 'center',
                gap: '3px',
            },
        },
        '& > *:not(:first-child)': {
            marginLeft: 0,
        },
    },
});

const lastTelestratedVideoLinkModal = ({
    telestrationStateMgr,
    classes,
}: IProps) => {
    const [copied, setCopied] = useState(false);
    const {
        state: { lastTelestratedVideo },
        dispatchAction,
    } = telestrationStateMgr;
    return (
        <Dialog
            open={lastTelestratedVideo ? true : false}
            // open={true}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => dispatchAction(setLastTelestratedVideo(''))}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
            classes={{ paper: classes.paper }}
        >
            <Box className={classes.dialogBox} style={{ maxWidth: '100%' }}>
                {/* <DialogTitle id='alert-dialog-slide-title'>
                    You can share telestrated video by sending this link
                </DialogTitle> */}
                <Grid
                    container
                    spacing={0}
                    alignItems='center'
                    className={classes.dialogHeader}
                >
                    <Grid item xs={9}>
                        <Box display='flex' alignItems='center'>
                            <img
                                src={SendIcon}
                                alt='edit video'
                                width='16'
                                height='16'
                                style={{ marginRight: 12 }}
                            />
                            <DialogTitle className={classes.dialogTitle}>
                                Share Clip
                            </DialogTitle>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box display='flex' justifyContent='flex-end'>
                            <span
                                // aria-label='Close modal'
                                onClick={() =>
                                    dispatchAction(setLastTelestratedVideo(''))
                                }
                                className={'close-icon'}
                            >
                                <CloseIcon />
                            </span>
                        </Box>
                    </Grid>
                </Grid>
                <DialogContent
                    style={{
                        padding: '16px 16px 0',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Box>
                        <label
                            style={{
                                display: 'block',
                                marginBottom: 8,
                                fontWeight: 500,
                            }}
                        >
                            Link
                        </label>
                        <TextField
                            value={lastTelestratedVideo}
                            fullWidth
                            placeholder='https//www.linkhere.com'
                            variant='outlined'
                            className={classes.videoTitle}
                        />
                    </Box>
                    {/* <Button
                            disabled={copied}
                            onClick={() => {
                                navigator.clipboard
                                    .writeText(lastTelestratedVideo)
                                    .then(
                                        () => {
                                            setCopied(true);
                                            setTimeout(() => {
                                                setCopied(false);
                                            }, 3000);
                                        },
                                        () => {
                                            console.error(
                                                'clipboard write failed'
                                            );
                                        }
                                    );
                            }}
                        >
                            {copied ? (
                                <div className={classes.copiedButton}>
                                    <CheckIcon fontSize='small' />
                                    Copied
                                </div>
                            ) : (
                                <FileCopyOutlinedIcon />
                            )}
                        </Button> */}
                </DialogContent>
                <DialogActions className={classes.buttonRow}>
                    <Button
                        variant='outlined'
                        className={classes.button}
                        onClick={() =>
                            dispatchAction(setLastTelestratedVideo(''))
                        }
                    >
                        Cancel
                    </Button>

                    <Button
                        disabled={copied}
                        variant='contained'
                        color='primary'
                        onClick={() => {
                            navigator.clipboard
                                .writeText(lastTelestratedVideo)
                                .then(
                                    () => {
                                        setCopied(true);
                                        setTimeout(() => {
                                            setCopied(false);
                                        }, 3000);
                                    },
                                    () => {
                                        console.error('clipboard write failed');
                                    }
                                );
                        }}
                    >
                        {copied ? (
                            <div className={'copied-style'}>
                                <CheckIcon fontSize='small' />
                                Copied
                            </div>
                        ) : (
                            <div className={'copied-style'}>Copy Link</div>
                        )}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};
export const LastTelestratedVideoLinkModal = flow(
    withStyles(styles),
    withTelestrationState
)(lastTelestratedVideoLinkModal);
